import React, { useState } from "react";
import { Check, Copy } from "lucide-react";

const CopyValueButton = ({ value, label = "Copy" }) => {
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const title = copied ? "Copied" : label;

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={title}
      aria-label={title}
      className="shrink-0 p-0.5 text-gray-400 hover:text-gray-600 rounded focus:outline-none focus:ring-1 focus:ring-gray-300 transition-colors"
    >
      {copied ? <Check className="h-3 w-3" aria-hidden /> : <Copy className="h-3 w-3" aria-hidden />}
    </button>
  );
};

export default CopyValueButton;
